/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import {
  AsyncPropSelector,
  B1,
  CustomMenu,
  CustomModal,
  DropdownIndicator,
  H2,
  IndicatorSeparator,
  Loader,
  TEXT_LENGTH,
  formatGroupLabel,
  getParsedCrudData,
  getTranslatedText,
  toast
} from '@nile/components';
import {
  AccountClient,
  GET_INVOICE_PAYMENT_METHODS,
  GET_INVOICE_PAYMENT_TERMS,
  MockTicketClient,
  UPDATE_INVOICE_PAYMENT_METHODS,
  UPDATE_INVOICE_PAYMENT_TERMS
} from '@nile/graphql';
import { useLazyQuery, useQuery } from '@apollo/client';
import { cloneDeep, isEmpty, isEqual, omit, sortBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import {
  Button,
  ButtonGroup,
  TextField,
  Link,
  TextStyle
} from '@superops/ui-design-system';
import OutsideClickListener from '@nile/components/src/Components/CreatableDropdown/components/OutsideClickListener';
import shortid from 'shortid';
import Select from 'react-select';

const EditSheet = styled.div`
  min-width: 700px;
  max-width: 80vh;
  width: auto;
  min-height: 450px;
  background: #ffffff;
  border-radius: 20px;

  .title {
    font-size: 20px;
    line-height: 21px;
  }

  .content {
    max-height: 70vh;
  }

  .Superops-InlineError {
    color: #bf0711;
  }

  .Superops-TextField--error > .Superops-TextField__Input {
    &:hover,
    &:focus,
    &:focus:hover {
      border-bottom: 0.1rem solid var(--sops-border-hover);
    }
  }
`;

const OptionContainer = styled.div`
  border-radius: 5px;
  .action-item {
    cursor: pointer;
    visibility: hidden;
  }
  ${(props) =>
    props.isEditing &&
    `background: #f1f6ff;
    .action-item {
      visibility: visible;
    }
  `}

  .Superops-TextField__Input {
    border-bottom: ${(props) =>
      props.readOnly
        ? '1px solid transparent !important'
        : '1px solid #eeeeee !important'};
  }

  ${(props) =>
    !props.readOnly &&
    `
    &:hover {
    background: #f1f6ff;
    .action-item {
      visibility: visible;
    }
    .Superops-TextField__Input {
      border-bottom: 1px solid transparent !important;
    }
  }`}
`;

const paymentObj = {
  term: {
    queryName: 'getPaymentTerms',
    query: GET_INVOICE_PAYMENT_TERMS,
    placeholder: 'client.invoice.settings.paymentTerm.choose.placeholder',
    nameKey: 'paymentTermName',
    valueKey: 'paymentTermValue',
    uniqueId: 'paymentTermId',
    updateApi: UPDATE_INVOICE_PAYMENT_TERMS,
    responseKey: 'updatePaymentTerms',
    apiInput: {
      add: 'addPaymentTerms',
      update: 'updatePaymentTerms',
      delete: 'deletePaymentTerms'
    }
  },
  method: {
    queryName: 'getPaymentMethods',
    query: GET_INVOICE_PAYMENT_METHODS,
    placeholder: 'client.invoice.settings.paymentMethod.choose.placeholder',
    nameKey: 'paymentMethodName',
    uniqueId: 'paymentMethodId',
    updateApi: UPDATE_INVOICE_PAYMENT_METHODS,
    responseKey: 'updatePaymentMethods',
    apiInput: {
      add: 'addPaymentMethods',
      update: 'updatePaymentMethods',
      delete: 'deletePaymentMethods'
    }
  }
};

const InvoicePaymentMethods = (props) => {
  const {
    paymentType,
    defaultValue,
    title,
    icon,
    onChange,
    disableConfigure = false
  } = props;
  const [configurePopupActive, setConfigurePopupActive] = useState(false);

  return (
    <>
      <CustomModal
        open={configurePopupActive}
        onClose={() => setConfigurePopupActive(false)}
      >
        <ManagePaymentOptions
          defaultValue={defaultValue}
          type={paymentType}
          closeModal={() => setConfigurePopupActive(false)}
        />
      </CustomModal>
      <div className="flex actr">
        <p div className="mr25 min-width-150">
          <FormattedMessage id={title || ''} />
        </p>
        <span className="fx actr mr8">
          <SVGIcon name={icon} />
        </span>
        <div className="mw-300">
          <PaymentDropdown
            type={paymentType}
            defaultValue={defaultValue}
            handleChange={onChange}
            setConfigurePopupActive={setConfigurePopupActive}
            disableConfigure={disableConfigure}
          />
        </div>
      </div>
    </>
  );
};

export const ManagePaymentOptions = (props) => {
  const { type, title, closeModal, defaultValue } = props;
  const paymentTypeObj = paymentObj[type];
  const {
    query,
    queryName,
    uniqueId,
    nameKey,
    valueKey,
    updateApi,
    apiInput,
    responseKey
  } = paymentTypeObj;
  const { data, loading, error } = useQuery(query, {
    client: AccountClient,
    fetchPolicy: 'no-cache'
  });
  const [options, setOptions] = useState([]);
  const [orgOptions, setOrgOptions] = useState([]);
  const [saveActionLoading, setSaveActionLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const intl = useIntl();

  useEffect(() => {
    if (data?.[queryName]) {
      setOptions(data[queryName]);
      setOrgOptions(data[queryName]);
    }
  }, [data]);

  function validateOptions() {
    let isInvalid = false;
    // const emptyOptions = options.some((opt) => isEmpty(opt[nameKey]));
    let clonedErrors = cloneDeep(errors);

    options
      .filter((opt) => !opt.systemPaymentTerm)
      .forEach((opt) => {
        let errorMsg = {};
        if (isEmpty(opt[nameKey])) {
          errorMsg = {
            ...errorMsg,
            name: getTranslatedText(intl, 'validation.description.empty')
          };
        }
        if (valueKey && isEmpty(opt[valueKey]?.toString() || '')) {
          errorMsg = {
            ...errorMsg,
            value: getTranslatedText(intl, 'value.validation.description.empty')
          };
        }

        if (isEmpty(errorMsg)) {
          delete clonedErrors?.[opt[uniqueId]];
        } else {
          clonedErrors = {
            ...clonedErrors,
            [opt[uniqueId]]: errorMsg
          };
        }
      });

    if (!isEmpty(clonedErrors)) {
      isInvalid = true;
      setErrors(clonedErrors);
    } else {
      setErrors(null);
    }
    return isInvalid;
  }

  function addNewOption() {
    const newData = { [uniqueId]: shortid.generate(), [nameKey]: '' };
    if (paymentTypeObj?.valueKey) {
      newData[paymentTypeObj?.valueKey] = null;
    }
    const clonedOptions = cloneDeep(options);
    clonedOptions.push(newData);
    setOptions(clonedOptions);
    setTimeout(() => {
      const elem = document.getElementById('paymentContainerRef');
      if (elem) {
        elem.scrollTop = elem?.scrollHeight;
      }
    }, 500);
    if (errors) setErrors(null);
  }

  function updateOptions(updatedData) {
    const clonedOptions = cloneDeep(options);
    const updatedOptionIdx = clonedOptions.findIndex(
      (opt) => opt[uniqueId] === updatedData[uniqueId]
    );
    if (updatedOptionIdx > -1) {
      clonedOptions[updatedOptionIdx] = updatedData;
    } else {
      clonedOptions.push(updatedData);
    }
    setOptions(clonedOptions);
    if (errors) setErrors(null);
  }

  function deleteOption(deletedData) {
    const clonedOptions = cloneDeep(options);
    const updatedOptions = clonedOptions.filter(
      (opt) => opt[uniqueId] !== deletedData[uniqueId]
    );
    setOptions(updatedOptions);
    if (errors) setErrors(null);
  }

  const {
    addedItems: addedOptions,
    updatedItems: updatedOptions,
    deletedItems: deletedOptions
  } = getParsedCrudData(orgOptions, options, uniqueId);

  function saveUpdatedOptions() {
    setSaveActionLoading(true);

    if (validateOptions()) {
      setSaveActionLoading(false);
      return;
    }

    function shapeOptions(optionsArr) {
      return optionsArr.map((option) =>
        omit(option, ['systemMethod', 'systemPaymentTerm', 'placeholder'])
      );
    }

    AccountClient.mutate({
      mutation: updateApi,
      variables: {
        input: {
          [apiInput.add]: shapeOptions(addedOptions).map((option) =>
            omit(option, ['paymentTermId', 'paymentMethodId'])
          ),
          [apiInput.update]: shapeOptions(updatedOptions),
          [apiInput.delete]: deletedOptions.map((option) => ({
            [uniqueId]: option[uniqueId]
          }))
        }
      }
    })
      .then((res) => {
        setSaveActionLoading(false);
        if (res?.data?.[responseKey]) {
          closeModal();
          toast('success', 'Invoice payment updated successfully');
        }
      })
      .catch((err) => {
        setSaveActionLoading(false);
      });
  }

  if (loading) return <Loader />;

  const saveEnabled =
    addedOptions.length || updatedOptions.length || deletedOptions.length;

  return (
    <EditSheet className="fw fhp br10">
      <div className="header fx actr fx-sb divider p20 pl40 pr40">
        <B1 className="title">
          {title ||
            getTranslatedText(
              intl,
              `client.invoice.settings.payment${type}.configure`
            )}
        </B1>
        <ButtonGroup>
          <Button plainSecondary onClick={closeModal}>
            <FormattedMessage id="common.cancel" />
          </Button>
          <Button
            onClick={saveUpdatedOptions}
            primary
            icon={<SVGIcon name="Save" size="sm" />}
            loading={saveActionLoading}
            disabled={!saveEnabled}
          >
            <FormattedMessage id="common.save" />
          </Button>
        </ButtonGroup>
      </div>
      {type === 'term' && (
        <div className="fx actr ml-40 mt20 pb10">
          <div
            className="mr-20 overflow-x-hidden text-color ellipsis w250"
            title={getTranslatedText(
              intl,
              'client.invoice.settings.paymentTerm.name'
            )}
          >
            <FormattedMessage id="client.invoice.settings.paymentTerm.name" />
          </div>
          <div
            className="overflow-x-hidden text-color ellipsis w250"
            title={getTranslatedText(
              intl,
              'client.invoice.settings.paymentTerm.numberOfDays'
            )}
          >
            <FormattedMessage id="client.invoice.settings.paymentTerm.numberOfDays" />
          </div>
        </div>
      )}
      <div id="paymentContainerRef" className="content scroll p20 pt-5">
        {sortBy(options, (obj) => !obj?.systemPaymentTerm).map((opt) => {
          const params = {
            option: opt,
            nameKey: nameKey,
            handleUpdate: updateOptions,
            handleDelete: deleteOption.bind(this, opt),
            error: errors?.[opt[uniqueId]] || null,
            // isEditable: !opt.systemPaymentTerm,
            isEditable: true,
            isDeletable:
              !opt?.systemPaymentTerm &&
              defaultValue?.[uniqueId] !== opt?.[uniqueId]
          };
          if (paymentTypeObj?.valueKey) {
            params.valueKey = paymentTypeObj?.valueKey;
          }
          return (
            <div key={opt?.[uniqueId]}>
              <Option {...params} />
            </div>
          );
        })}
      </div>
      <div className="d-in-f actr pl40 pt10 pb20">
        <span className="fx mr10">
          <SVGIcon name="add" color="#0000FF" />
        </span>
        <Link onClick={addNewOption} removeUnderline>
          <FormattedMessage id="client.details.info.add" />
        </Link>
      </div>
    </EditSheet>
  );
};

const Option = (props) => {
  const wrapperRef = React.createRef();
  const {
    option,
    nameKey,
    valueKey,
    handleDelete,
    handleUpdate,
    error,
    isEditable,
    isDeletable
  } = props;
  const [optionObj, setOptionObj] = useState(option);
  const [editMode, setEditMode] = useState(false);

  const toggleEdit = () => {
    setEditMode(!editMode);
  };

  const handleChange = (fieldName, fieldType) => {
    return (val) => {
      setOptionObj({
        ...optionObj,
        [fieldName]: fieldType === 'number' ? Math.abs(Math.floor(val)) : val
      });
    };
  };

  useEffect(() => {
    if (!isEqual(option, optionObj)) {
      handleUpdate(optionObj);
    }
  }, [optionObj]);

  return (
    <OptionContainer
      isEditing={editMode}
      readOnly={!isEditable}
      className="fx fw actr p20 pt10 pb10"
    >
      <div
        ref={wrapperRef}
        onClick={() => setEditMode(true)}
        className="fx actr"
      >
        <TextField
          readOnly={!isEditable}
          // focused={editMode}
          value={optionObj[nameKey]}
          onChange={handleChange(nameKey)}
          type="text"
          size="small"
          error={error?.name}
          maxLength={TEXT_LENGTH.size_5}
        />
        {valueKey ? (
          option?.systemPaymentTerm ? (
            <TextStyle variation="subdued">
              <span className="ml20 cursor-not-allowed">
                <FormattedMessage
                  id={optionObj?.placeholder || 'app.noData.message'}
                />
              </span>
            </TextStyle>
          ) : (
            <span className="ml20">
              <TextField
                readOnly={!isEditable}
                value={String(optionObj?.[valueKey])}
                onChange={handleChange(valueKey, 'number')}
                type="number"
                size="small"
                error={error?.value}
                min={0}
                max={180}
              />
            </span>
          )
        ) : null}
      </div>
      <OutsideClickListener
        reference={wrapperRef}
        onOutsideClick={() => setEditMode(false)}
      />
      <div className="mlauto">
        {/* <span className="action-item" onClick={toggleEdit}>
          <SVGIcon name="edit" />
        </span> */}
        {isDeletable && (
          <span className="ml20 action-item" onClick={handleDelete}>
            <SVGIcon name="delete" />
          </span>
        )}
      </div>
    </OptionContainer>
  );
};

const PaymentDropdown = (props) => {
  const {
    type,
    defaultValue,
    setConfigurePopupActive,
    handleChange,
    disableConfigure = false
  } = props;
  const intl = useIntl();
  const [menuOpen, setMenuOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const paymentType = paymentObj[type];

  const updateSelection = (val) => {
    // console.log('updateSelection', f, val);
    const selectedObject = cloneDeep(val);
    handleChange(omit(selectedObject, ['value', 'label']));
  };

  const shapeOptions = (data) => {
    let optionsArray = data?.[paymentType?.queryName] || data;
    switch (paymentType?.queryName) {
      case 'getPaymentTerms':
        optionsArray = optionsArray?.map((option) => ({
          ...option,
          value: option.paymentTermId,
          label: option.paymentTermName
        }));
        break;
      default:
        optionsArray = optionsArray?.map((option) => ({
          ...option,
          value: option.paymentMethodId,
          label: option.paymentMethodName
        }));
        break;
    }
    return optionsArray;
  };

  const generateOptions = shapeOptions;

  const divideOptions = (data) => {
    let optionsArray = data?.[paymentType?.queryName] || data;
    switch (paymentType?.queryName) {
      case 'getPaymentTerms':
        optionsArray = [
          {
            label: getTranslatedText(
              intl,
              'client.invoice.settings.paymentTerm.systemTerms'
            ),
            options: generateOptions(
              optionsArray.filter((opt) => opt.systemPaymentTerm)
            )
          },
          {
            label: getTranslatedText(
              intl,
              'client.invoice.settings.paymentTerm.userTerms'
            ),
            options: generateOptions(
              optionsArray.filter((opt) => !opt.systemPaymentTerm)
            )
          }
        ];
        break;
      default:
        optionsArray = generateOptions(data);
        break;
    }
    return optionsArray;
  };

  const getDynamicQuery = () => {
    const { query } = paymentType;
    setLoading(true);
    // return MockTicketClient.query({ query: query });
    return AccountClient.query({
      query: query,
      fetchPolicy: 'network-only'
    }).then((res) => {
      if (res.data) {
        setOptions(divideOptions(res.data));
        setLoading(false);
      }
    });
  };

  const CustomMenuWithActions = (allProps) => {
    if (disableConfigure) return <CustomMenu {...allProps} />;
    return (
      <CustomMenu
        {...allProps}
        actionComponent={
          <div
            className="ellipsis full-width cp pl-12 pr12 bg-blue"
            onClick={() => {
              setConfigurePopupActive(true);
            }}
          >
            <div className="d-in-f center">
              <FormattedMessage
                id={`client.invoice.settings.payment${type}.configure`}
              />
            </div>
          </div>
        }
      />
    );
  };

  return (
    <div className="fw min-w-250 mw-100 grow-1 pr10">
      <Select
        className="propSelector"
        onMenuOpen={async () => {
          await getDynamicQuery();
          setMenuOpen(true);
        }}
        onMenuClose={() => {
          setMenuOpen(false);
        }}
        key={defaultValue ? shapeOptions([defaultValue]) : null}
        classNamePrefix="value_selector"
        formatGroupLabel={formatGroupLabel}
        defaultValue={defaultValue ? shapeOptions([defaultValue]) : null}
        onChange={updateSelection}
        options={options}
        placeholder={getTranslatedText(intl, 'admin.slaPolicy.chooseValue')}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        noOptionsMessage={() => {
          return loading ? 'Loading...' : 'No options';
        }}
        maxMenuHeight={150}
        isMulti={false}
        isLoading={loading}
        menuIsOpen={menuOpen}
        components={{
          IndicatorSeparator,
          DropdownIndicator: (props) => <DropdownIndicator {...props} />,
          Menu: CustomMenuWithActions
        }}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 })
        }}
        closeMenuOnScroll={(e) => {
          return (
            e.target &&
            e.target.classList &&
            !(e.target.classList.value.indexOf('menu-list') > -1)
          );
        }}
      />
    </div>
  );
};

// const PaymentDropdown = (props) => {
//   const { type, defaultValue, setConfigurePopupActive, handleChange } = props;

//   const paymentType = paymentObj[type];

//   const updateSelection = (f, val) => {
//     // console.log('updateSelection', f, val);
//     const selectedObject = cloneDeep(val);
//     handleChange(omit(selectedObject, ['value', 'label']));
//   };

//   const shapeOptions = (field, data) => {
//     let optionsArray = data?.[field] || data;
//     switch (field) {
//       case 'getPaymentTerms':
//         optionsArray = optionsArray?.map((option) => ({
//           ...option,
//           value: option.paymentTermId,
//           label: option.paymentTermName
//         }));
//         break;
//       default:
//         optionsArray = optionsArray?.map((option) => ({
//           ...option,
//           value: option.paymentMethodId,
//           label: option.paymentMethodName
//         }));
//         break;
//     }
//     return optionsArray;
//   };

//   const generateOptions = shapeOptions;

//   const dynamicQuery = () => {
//     const { query } = paymentType;
//     // return MockTicketClient.query({ query: query });
//     return AccountClient.query({ query: query });
//   };

//   const isAddRequesterVisible = true;

//   const CustomMenuWithActions = (allProps) => {
//     const { innerRef, innerProps, isDisabled, children } = allProps;
//     if (isAddRequesterVisible) {
//       return (
//         <CustomMenu
//           {...allProps}
//           actionComponent={
//             <OptionButton
//               className="ellipsis full-width cp"
//               onClick={() => {
//                 setConfigurePopupActive(true);
//               }}
//             >
//               <div className="d-in-f center">
//                 <div className="ml-5">
//                   <FormattedMessage
//                     id={`client.invoice.settings.payment${type}.configure`}
//                   />
//                 </div>
//               </div>
//             </OptionButton>
//           }
//         />
//       );
//     }
//     return !isDisabled ? (
//       <div ref={innerRef} {...innerProps} className="customReactSelectMenu">
//         {children}
//       </div>
//     ) : null;
//   };

//   return (
//     <Field>
//       <AsyncPropSelector
//         autoFocus
//         hideTitle
//         isDynamicQuery
//         variables={null}
//         defaultValue={shapeOptions(
//           paymentType?.queryName,
//           defaultValue ? [defaultValue] : []
//         )}
//         updateSelection={updateSelection}
//         generateOptions={generateOptions}
//         entity={paymentType?.queryName}
//         field={paymentType?.queryName}
//         onKeyDown={updateSelection}
//         dynamicQuery={dynamicQuery}
//         placeholder={paymentType?.placeholder}
//         customMenuOptions={CustomMenuWithActions}
//       />
//     </Field>
//   );
// };

export default InvoicePaymentMethods;
